import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import contenuFr from "./contenu-fr.js";
import contenuEn from "./contenu-en.js";
import "./famille.css";

/**
 * Portrait « Un verre de chablis chez Anne » (FR) / "A Glass of Chablis with Anne" (EN), signé Ben.
 * Remplace le récit « Les adresses de la famille Yvois » en conservant les mêmes routes,
 * pour ne pas rompre les liens existants. Le layout fournit header, footer et sélecteur de langue.
 * Les images s'ouvrent dans la lightbox du site ; les liens internes utilisent la navigation SPA.
 */
export default function FamilleYvois({ locale = "fr" }) {
  const host = useRef(null);
  const navigate = useNavigate();
  const [zoom, setZoom] = React.useState(null); // { src, alt }
  const isEnglish = locale === "en";

  useEffect(() => {
    const root = host.current;
    if (!root) return undefined;

    const onClick = (e) => {
      // Zoom sur les figures
      const zoomBtn = e.target.closest(".famille-yvois .zoom");
      if (zoomBtn) {
        const img = zoomBtn.querySelector("img");
        if (img) setZoom({ src: img.src, alt: img.alt });
        return;
      }

      // Navigation SPA pour les liens internes (href commençant par "/")
      const a = e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("/")) {
        e.preventDefault();
        const [path, hash] = href.split("#");
        navigate(path);
        if (hash) {
          setTimeout(() => {
            const t = document.getElementById(hash);
            if (t) t.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 350);
        } else {
          window.scrollTo(0, 0);
        }
      }
      // Sinon lien externe : comportement par défaut
    };

    root.addEventListener("click", onClick);
    return () => root.removeEventListener("click", onClick);
  }, [isEnglish, navigate]);

  return (
    <div className="bg-[#f8f2e6]">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-12 lg:py-16">
        <div
          ref={host}
          data-testid={`page-famille-${locale}`}
          className="famille-yvois"
          dangerouslySetInnerHTML={{ __html: isEnglish ? contenuEn : contenuFr }}
        />
      </div>

      <Dialog open={!!zoom} onOpenChange={(o) => !o && setZoom(null)}>
        <DialogContent className="max-w-[96vw] border-0 bg-[#fffaf0] p-2">
          {zoom && (
            <>
              <p className="text-center font-serif text-[#254336] text-base mb-2 px-2">{zoom.alt}</p>
              <img src={zoom.src} alt={zoom.alt} className="mx-auto max-w-[90vw] max-h-[76vh] object-contain" />
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
